import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Colors, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  ${Mixins.Flex.center()}
`;

export const Input = styled.input.attrs(() => ({
  type: 'search',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
  required: true,
  maxLength: 100,
}))<{ hasIcon?: boolean }>`
  background: none;
  border: none;
  margin: 0;
  padding: 1px 0 0 0;
  outline: none;
  height: 100%;
  width: 100%;
  caret-color: ${Colors.RADISH};

  ${ifProp(
    'hasIcon',
    css`
      padding: 0 0 0 ${Spacing.DOUBLE};
    `,
    css`
      padding: 0 0 0 ${Spacing.SINGLE};
    `
  )}
`;

export const ClearButton = styled.button`
  border: none;
  background: none;
  transform: translateX(-${Spacing.HALF});
  font-size: 12px;
`;

export const IconContainer = styled.div`
  ${Mixins.Flex.center()}
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${Spacing.DOUBLE};

  & svg {
    transform: translateY(-1px);
  }
`;
